import React, { useEffect, useState } from "react";
import styles from "./app.module.css";
import { AnimatePresence } from "framer-motion";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import MythMap from "./components/mythMap/MythMap";
import SiteFooter from "./components/siteFooter/SiteFooter";
import About from "./pages/about/About";
// import MythExplorer from "./pages/mythExplorer/MythExplorer";
import MythMaker from "./pages/mythMaker/MythMaker";
import MythViewer from "./pages/mythViewer/MythViewer";
import { app } from "./helpers/myFirebase";

const db = app.firestore();

export default function App() {
  const [mythData, setMythData] = useState([]);

  useEffect(() => {
    db.collection("myths").onSnapshot((snapshot) => {
      const tempMyths = [];
      snapshot.forEach((doc) => {
        tempMyths.push({ ...doc.data(), id: doc.id });
      });

      setMythData(tempMyths);
    });
  }, []);

  return (
    <div className={styles.app}>
      <Router>
        <>
          <MythMap mythData={mythData} />

          <Route
            render={({ location }) => (
              <AnimatePresence exitBeforeEnter initial={false}>
                <Switch location={location} key={location.pathname}>
                  {/* <Route
                    exact
                    path="/"
                    component={() => <MythExplorer mythData={mythData} />}
                  /> */}
                  <Route
                    exact
                    path="/explorer/:id"
                    component={() => <MythViewer mythData={mythData} />}
                  />
                  <Route
                    exact
                    path="/maker/"
                    component={() => <MythMaker mythData={mythData} />}
                  />
                  <Route
                    exact
                    path="/maker/:id"
                    component={() => <MythMaker mythData={mythData} />}
                  />

                  <Route exact path="/about/" component={About} />
                </Switch>
              </AnimatePresence>
            )}
          />

          <SiteFooter />
        </>
      </Router>
    </div>
  );
}
